import { AgentType } from '@server/ai';

export const emptyStateLeadMonitoring = (crmOrgId: string) => {
  return {
    id: 'lead-monitoring-agent',
    name: 'Lead Monitoring',
    type: AgentType.MonitoringV2,
    updatedAt: new Date().toISOString(),
    files: [],
    orgId: crmOrgId ?? '',
    contextComponents: [],
    bestPractices: [],
    issues: [],
    facts: [],
    activeScan: undefined,
  };
};

export const emptyStateFlowMonitoring = (crmOrgId: string) => {
  return {
    id: 'flow-monitoring-agent',
    name: 'Flow Monitoring',
    type: AgentType.MonitoringV2,
    updatedAt: new Date().toISOString(),
    files: [],
    orgId: crmOrgId ?? '',
    contextComponents: [],
    bestPractices: [],
    issues: [],
    facts: [],
    activeScan: undefined,
  };
};
